export default __webpack_public_path__ + "static/media/Logo-Icon-Regular.39cd560e.svg";